var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackingToolsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.04,
    height: 38.4,
    rx: 8,
    fill: "#EBF2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8533 24.8667V17.7834M19.52 24.8667V13.5334M25.1867 24.8667V22.0334M20.9367 7.8667H11.02C9.45519 7.8667 8.18667 9.13522 8.18667 10.7V27.7C8.18667 29.2649 9.45519 30.5334 11.02 30.5334H28.02C29.5849 30.5334 30.8533 29.2649 30.8533 27.7V17.7834",
    stroke: "#0069CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingToolsImage);
export default __webpack_public_path__ + "static/media/Tracking-tools-image.40efaa89905846e0164fce20a4cf5389.svg";
export { ForwardRef as ReactComponent };